export default function BoxIcon({ width = 24, height = 24, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="m20.97 6.202-8.25-4.514a1.489 1.489 0 0 0-1.44 0L3.03 6.204a1.5 1.5 0 0 0-.78 1.312v8.966a1.5 1.5 0 0 0 .78 1.313l8.25 4.516a1.489 1.489 0 0 0 1.44 0l8.25-4.516a1.5 1.5 0 0 0 .78-1.313V7.517a1.5 1.5 0 0 0-.78-1.315ZM12 3l7.533 4.125-2.792 1.527-7.533-4.125L12 3Zm0 8.25L4.467 7.125l3.18-1.74 7.532 4.124L12 11.25Zm8.25 5.236-7.5 4.105v-8.044l3-1.642v3.345a.75.75 0 1 0 1.5 0v-4.166l3-1.642V16.486Z"
      />
    </svg>
  );
}
